<template>
  <button :class="classes" :disabled="disabled" v-if="to === ''">
    <slot></slot>
  </button>

  <router-link :class="classes" v-else :to="to">
    <slot></slot>
  </router-link>
</template>

<script>
export default {
  name: 'VButton',
  props: {
    to: {
      type: String,
      default: ''
    },
    block: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    }
  },
  computed: {
    classes () {
      let classes = 'btn'

      if (this.color) {
        classes += ` btn--${this.color}`
      }

      if (this.size) {
        classes += ` btn--${this.size}`
      }

      if (this.block) {
        classes += ' btn--block'
      }

      if (this.disabled) {
        classes += ' btn--disabled'
      }

      return classes
    }
  }
}
</script>

<style lang="stylus" scoped>
  .btn
    border none
    box-shadow none
    padding 0px 15px
    height 32px
    line-height 32px
    font-size 14px
    text-transform uppercase
    font-weight 700
    background #423799
    color #fff
    border-radius 5px
    cursor pointer
    text-decoration none
    text-align center
    display inline-flex
    align-items center
    justify-content center
    vertical-align middle
    white-space nowrap
    box-sizing border-box

    &--block
      display flex
      width 100%
      max-width 100%

    &--disabled
      pointer-events none
      opacity 0.6

    &--small
      height 27px
      line-height 27px
      padding 0px 10px
      font-size 11px
      width 100px

    &--icon
      height 28px
      width 28px
      padding 0
      font-size 12px
      text-transform none

    &--danger
      background #c0392b
      color #fff

    &--secondary
      background #f5f5f5
      color #333
      border 1px solid #ddd

      &:hover
        background #e8e8e8
</style>



// WEBPACK FOOTER //
// VButton.vue?7fe34e18